import { Pharmacy } from '@abiglobalhealth/go-types'

import { Location } from '@/components/icons/Location'

interface PharmacyCardProps {
  pharmacy: Pharmacy
  onClick: (_: Pharmacy) => void
  isSelected?: boolean
}

export const PharmacyCard = ({ pharmacy, onClick, isSelected }: PharmacyCardProps) => {
  return (
    <button
      className={`hover:bg-primary-light flex w-full flex-col gap-4 rounded-sm border px-4 py-6 shadow-sm transition-[color,border-color] ${isSelected ? 'border-primary bg-primary-light' : 'border-transparent bg-white'}`}
      onClick={() => onClick(pharmacy)}
    >
      <label className="w-fit font-bold">{pharmacy.name}</label>
      <div className="flex items-center gap-3">
        <Location customClassName="text-primary h-8 min-w-[23px]" />
        <label className="text-gray-text text-sm">{pharmacy.address}</label>
      </div>
    </button>
  )
}
